/* @flow */

import React, { useContext } from "react";
import { NotificationBar } from "@crossroads/ui-components";
import { useNotification } from "helpers/use-notification";
import { useTranslate } from "@awardit/react-use-translate";
import { useLocation } from "react-router";
import { StoreInfoContext } from "entrypoint/shared";
import cn from "classnames";

import styles from "./styles.scss";

const Notifications = () => {
  const t = useTranslate();
  const location = useLocation();
  const { info } = useContext(StoreInfoContext);
  const onCheckout = ((location ? location.pathname : "").includes("checkout") ||
    (location ? location.pathname : "").includes("buy-and-transfer-points/")) &&
    !(location ? location.pathname : "").includes("success");
  const {
    showAddressNotificationBar,
    showNotificationBar,
    setShowAddressNotificationBar,
    setShowNotificationBar,
    showMiniBanner,
    headerNotificationsActive,
  } = useNotification();

  return (
    <>
      {showAddressNotificationBar &&
        <NotificationBar
          text={t("MISSING_ADDRESS_TEXT")}
          closeBtnTitle={t("NOTIFICATIONBAR.CLOSE")}
          onClose={() => setShowAddressNotificationBar(false)}
        />
      }
      {showMiniBanner && !onCheckout &&
        <NotificationBar
          closeBtnTitle={t("NOTIFICATIONBAR.CLOSE")}
          wrapperClassName={cn(
            styles.miniBannerWrapper,
            {
              [styles.extraTop]: showAddressNotificationBar,
            }
          )}
          className={styles.miniBanner}
          text="<p>test of the new mini banner</p>"
          onClose={() => {}}
        />
      }
      {showNotificationBar &&
        <NotificationBar
          wrapperClassName={cn({ [styles.bottom]: headerNotificationsActive > 0 })}
          text={info.popUp?.body}
          closeBtnTitle={t("NOTIFICATIONBAR.CLOSE")}
          onClose={() => setShowNotificationBar(false)}
        />
      }
    </>
  );
};

export default Notifications;
